import dayjs from 'dayjs'
import arraySupport from 'dayjs/plugin/arraySupport'
import duration from 'dayjs/plugin/duration'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)
dayjs.extend(arraySupport)
dayjs.extend(duration)
